import { PivotTableProps } from 'components/pivot-table/PivotTable'
import { capitalize, titleCase } from 'util/strConversor'

import { Absenteismo } from './Absenteismo'

const INDISPONIVEL = 'Indisponível'
const SEM_EQUIPE = 'Sem equipe'
const SEM_CATEGORIA = 'Sem categoria'

export const absenteismoKeyMapping: PivotTableProps<Absenteismo>['keyMapping'] = new Map([
  [
    'categoriaProfissional',
    {
      keyName: 'Categoria profissional',
      formatter: capitalize,
      ordenator: (a: string, b: string) => {
        if (a === SEM_CATEGORIA) {
          return -1
        } else if (b === SEM_CATEGORIA) {
          return 1
        } else {
          return a > b ? 1 : -1
        }
      },
    },
  ],
  [
    'nomeEquipe',
    {
      keyName: 'Equipe',
      formatter: capitalize,
      ordenator: (a: string, b: string) => {
        if (a === SEM_EQUIPE) {
          return -1
        } else if (b === SEM_EQUIPE) {
          return 1
        } else {
          return a > b ? 1 : -1
        }
      },
    },
  ],
  ['nomeMunicipio', { keyName: 'Município', formatter: titleCase }],
  ['nomeProfissional', { keyName: 'Profissional', formatter: titleCase }],
  ['nomeSituacaoAgendamento', { keyName: 'Tipo de falta', formatter: capitalize }],
  ['nomeUnidadeSaude', { keyName: 'Unidade de saúde', formatter: titleCase }],
  ['turno', { keyName: 'Turno', formatter: capitalize }],
  [
    'intervaloAgendamento',
    {
      keyName: 'Tempo entre agendamento e consulta',
      formatter: capitalize,
      ordenator: (a: string, b: string) => {
        if (a === INDISPONIVEL) {
          return -1
        } else if (b === INDISPONIVEL) {
          return 1
        } else {
          const num1 = Number(a.split(' ')[0])
          const num2 = Number(b.split(' ')[0])
          return num1 - num2
        }
      },
    },
  ],
])
